<template>
  <b-col class="c305  rounded rounded-5">
    <b-container>
      <m-img class="w-100 p-0 mx-0 my-3" :src="image" :alt="alt"/>
      <div class="c305-bottom-position col-lg-12">
        <slot name="p-1"></slot>
      </div>
    </b-container>
  </b-col>
</template>

<script>
export default {
  name: "C305",
  props: {
    image: {
      default: 'https://picsum.photos/1280/720'
    },
    alt: {
      default: 'mix it web'
    }
  }
}
</script>

<style scoped>
.c305 * {
  transition: .3s ease-in-out all;
}

.c305 {
  height: 360px;
}

.c305 img {
  width: 100%;
  height: 250px;
  object-fit: cover;
}

.c305:hover > .container img {
  transform: scale(1.1);
  transition: .3s ease-in-out all;
}

.c305-bottom-position {
  position: absolute;
  bottom: 10px;
  right: 0;
  left: 0;
}

</style>